import { useUserInformationContext } from 'contexts/userContext';
import React from 'react';
import { Redirect } from 'react-router';
import { useTranslation } from 'react-i18next';

import BackdropLoading from '../../common/BackdropLoading';

type PageCheckerUnOnboardedProps = {
  render: () => React.ReactElement;
};

const PageCheckerUnOnboarded = ({ render }: PageCheckerUnOnboardedProps) => {
  const { isCurrentUserLoading, currentUser } = useUserInformationContext();
  const { t } = useTranslation();

  if (isCurrentUserLoading) {
    return <BackdropLoading open loadingText={t('common:loading')} />;
  }

  if (currentUser && !currentUser.onboarded) {
    return <Redirect to="/onboarding/terms-and-conditions" />;
  }

  return render();
};

export default PageCheckerUnOnboarded;
